
//to call a rout from button
// :to="{name: 'profile-edit', params: { endPoint: $route.params.endPoint,id:$route.params.id }}"

//to call a normal route
//this.$router.push("/").catch(() => {});

//to call name route
//this.$router.push({ name: 'page-error-404'});

//get the year only value must me a date
// var split = value.toISOString().split("-"); 
// value = split[0];


//to get the date
// var split = value.toISOString().split("T"); 
// value = split[0];

//to get the base url for axios
//testing: axios.defaults.baseURL, //http://altus.apps.my/v1

//foreach example
// element.items.forEach(el => {
//     if (this.isset(el, "submenu")) {
//       el.submenu = el.submenu.filter(f =>
//         myPermission.includes(f.permissionName)
//       );
//     }
//   });

//hand Emit
//consumer:  @addnew="(value) => addnew(value)"
//trigger: this.$emit("changeView","view");

//store sample
//this.$store.state.main.AppActiveUser.userRole

//  this.$route.params.subject,

//send query params and open router to new tab
//this.poCurrency = this.$route.query.poCurrency;
// let routeData = this.$router.resolve({
//     name: "PO",
//     query: {
//       poCurrency: this.getMainInfo.poCurrency,
//       userId: this.getMainInfo.userId,
//       poVendorId: this.getMainInfo.poVendorId,
//       id: this.getMainInfo.id,
//       logo:this.getSystemSettings.logo,
//     }
//   });
//   window.open(routeData.href, "_blank");


export const helperMixin = {
    methods: {
        displayCurrency(currency, value) {
            try {
                if (value != "") {
                    console.log("valueTemp:", value);
                    if (isNaN(value)) {
                        return "";
                    } else {
                        return currency + " " + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                    }
                }
                return "";
            } catch (e) {
                return "Error from DisplayCurrency, currency : " + currency + " value: " + value;
            }

        },
        isset(obj, needle) {
            return obj.hasOwnProperty(needle);
        },
        getFileExtention(filename) {
            return filename.split('.').pop();
        },
        capitalizeFirstLetter(string) {
            if (string != null && string != "") {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
            return "";
        },
        arrayFind(thArray, theValue) {
            return thArray.includes(theValue);
        },
        arrayOfObjectFind(thArrayOfObject, theValue) {

            return _.filter(thArrayOfObject, (n) => n.id == theValue)

        },

        stringContain(string, word) {
            return string.includes(word);
        },
        getSelectedOnLevelObj(obj, keyTofind, valueToFind) {
            return _.find(obj, function (o) {
                return o[keyTofind] == valueToFind;
            });
        },

        removeItemInObject(obj, objId, val) {
            return _.remove(obj, function (n) {
                return n[objId] != val;
            });
        },
        updateItemInObject(objToUpdate, objId, objIdToUpdate, objToLoopthrough) {
            //objToUpdate==========
            // data: [
            //     {
            //         dataName: "totalApprovedPR",
            //         label: "Approved PR",
            //         icon: "ThumbsUpIcon",
            //         type: "StatisticsCardLine",
            //         value: ""
            //     },
            //     {
            //         dataName: "others",
            //         label: "Approved PR",
            //         icon: "ThumbsUpIcon",
            //         type: "StatisticsCardLine",
            //         value: ""
            //     }
            // ]

            //objToLoopthrough
            // { 'totalApprovedPR' : 100, 'others' : 10 }

            //to call it: this.updateItemInObject(this.settings.data,'dataName','value',response.data.values);


            const entries = Object.entries(objToUpdate);
            for (const [itemIndex, itemValue] of entries) {
                console.log("ItemValue:", itemValue);
                console.log("objid:", itemValue[objId]);
                console.log("objToLoopthrough:", objToLoopthrough[itemValue[objId]]);
                objToUpdate[itemIndex][objIdToUpdate] = objToLoopthrough[itemValue[objId]]
                console.log("obj:", objToUpdate);
            }


        },
        countObject(obj) {
            return Object.entries(obj).length
        },
        addToFirst(obj, item) {
            return obj.splice(index, 0, item);
        },
        addToObject(obj, newObj) {
            return Object.assign(obj, newObj);
        },
        decodeValueForSelect(options, value) {
            var data = this.arrayOfObjectFind(options, value);
            if (this.countObject(data) > 0) {
                return data[0].label;
            } else {
                return "";
            }
        },
        flattenJsonStringArray(jsonStringArray, field) {

            if (jsonStringArray != null && jsonStringArray != undefined && jsonStringArray != "") {
                var str = "";
                var jsonString = JSON.parse(jsonStringArray)
                if (_.isArray(jsonString)) {
                    jsonString.forEach(element => {
                        if (str == "") {
                            str = element[field];
                        } else {
                            str = str + ", " + element[field];
                        }
                    });

                    return str;
                }

                return jsonString[field];

            }

            return "";
        },
        parseFromISOToLong(date) {
            return new Date(date).toDateString();
        },
        replaceAll(str, find, replace) {
            var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
            return str.replace(new RegExp(escapedFind, 'g'), replace);
        }

    }
}
